// Transfer events for ETH or ERC20 tokens have the structure { from, to, value }.
// This determines the relative amount of a given asset that has been transfered in
// or out of ourWalletAddress as a number unit, assuming each item in the `transfers`
// array is a transfer for that asset. If we sent more than we received, the value is negative.

export default function getValueOfTransfers(ourWalletAddress, asset, transfers) {
  return transfers
    .reduce((balanceDifference, { from, to, value }) => {
      const transferAmount = asset.currency.baseUnit(value)

      if (from === ourWalletAddress) {
        balanceDifference = balanceDifference.sub(transferAmount)
      }

      if (to === ourWalletAddress) {
        balanceDifference = balanceDifference.add(transferAmount)
      }

      return balanceDifference
    }, asset.currency.ZERO)
    .to(asset.ticker)
}
